import { ViewIds } from '@ardoq/api-types';
import { exhaustiveCheck } from '@ardoq/common-helpers';
import { isViewWithoutFullyGroupingSupport } from 'views/environmentals/getViewpointModeSupportedViews';

export const getRestrictedGroupingWarningMessage = (
  isViewSelectorWarning: boolean,
  viewId: ViewIds
) => {
  if (!isViewWithoutFullyGroupingSupport(viewId)) {
    return;
  }

  switch (viewId) {
    case ViewIds.BUBBLE: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in Bubble chart.';
    }
    case ViewIds.COMPONENT_MATRIX_2: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in Component Matrix.';
    }
    case ViewIds.SURFACE_3D: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in 3D Surface chart.';
    }
    case ViewIds.CONTOUR: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in Contour chart.';
    }
    case ViewIds.SPIDER_2: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in Spider chart.';
    }
    case ViewIds.POLAR: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in Polar chart.';
    }
    case ViewIds.SCATTER_3D: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in 3D Scatter chart.';
    }
    case ViewIds.BUBBLE_3D: {
      return isViewSelectorWarning
        ? 'Groups are not shown in this view style.'
        : 'Groups are not shown in 3D Bubble chart.';
    }
    default:
      return exhaustiveCheck(viewId);
  }
};
